import { Link } from "react-router";
import { Button, Stack, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { PlanValidationError } from "../types/PlanValidationError.ts";

type NavigationButtonsProps = {
  backHref?: string;
  nextHref?: string;
  backEnabled: boolean;
  nextEnabled: boolean;
  onBackClick?: () => void;
  onNextClick?: () => void;
  validationError?: PlanValidationError;
  showBackToSolutionsButton?: boolean;
};

export const NavigationButtons = ({
  backHref,
  nextHref,
  backEnabled,
  nextEnabled,
  onBackClick = () => undefined,
  onNextClick = () => undefined,
  validationError,
  showBackToSolutionsButton = false,
}: NavigationButtonsProps) => (
  <Stack direction={"row"} justifyContent={"space-between"}>
    <Button
      // if there is a backHref, treat as link, otherwise treat as button
      {...(backHref
        ? { component: Link, to: backHref }
        : { onClick: onBackClick })}
      variant="outlined"
      color="primary"
      disabled={!backEnabled}
      startIcon={<ChevronLeftIcon />}
    >
      Back
    </Button>

    <Stack direction="row" spacing={2} sx={{ alignItems: "baseline" }}>
      {validationError && (
        <Typography variant={"body2"}>{validationError.description}</Typography>
      )}
      <Button
        variant="contained"
        color="primary"
        // if there is a nextHref, treat as link, otherwise treat as form submit
        {...(nextHref ? { component: Link, to: nextHref } : { type: "submit" })}
        disabled={!nextEnabled}
        onClick={onNextClick}
        name="next"
        endIcon={<ChevronRightIcon />}
      >
        Next
      </Button>
      {showBackToSolutionsButton && (
        <Button
          variant="outlined"
          color="primary"
          type="submit"
          disabled={!nextEnabled}
          name="backToSolutions"
        >
          All solutions
        </Button>
      )}
    </Stack>
  </Stack>
);
